import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-16 pb-12 px-4 bg-white text-center" data-id="element-122">
      <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-123">
        <div className="inline-block bg-purple-100 text-purple-800 font-bold px-4 py-2 rounded-full mb-6 border-2 border-purple-200 shadow-sm uppercase tracking-wide text-sm md:text-base" data-id="element-124">
          🟣 Para personas que quieren desinflamarse y recuperar energía
        </div>

        <h1 className="text-5xl md:text-7xl font-black text-gray-900 mb-6 leading-tight tracking-tight" data-id="element-125">
          <span className="text-red-600 block mb-2" data-id="element-126">RESET CORPORAL 30D</span>
        </h1>

        <a href="#compra" onClick={scrollToPricing} className="block cursor-pointer hover:opacity-95 transition-opacity mb-8 w-full max-w-xl mx-auto" data-id="element-127">
          <img src="https://cdn.magicpatterns.com/uploads/3dBhkFSYF3eHnQmBM7ta8J/ChatGPT_Image_26_feb_2026,_14_30_27.png" alt="Reset Corporal 30D - Sistema Completo" className="w-full mx-auto rounded-xl shadow-2xl border-4 border-gray-100" data-id="element-128" />
        </a>

        <p className="text-xl md:text-2xl text-gray-700 font-medium mb-10 max-w-2xl mx-auto leading-relaxed text-center" data-id="element-129">
          El sistema estructurado para transformar tu cuerpo en 30 días. Menos
          inflamación, más energía y hasta 4–5 kg menos sin dietas extremas.
        </p>

        <div className="mb-6 w-full flex justify-center" data-id="element-130">
          <CTAButton text="SÍ, QUIERO HACER MI RESET AHORA" data-id="element-131" />
        </div>

        <div className="flex items-center justify-center text-gray-600 font-semibold mt-6" data-id="element-132">
          <ShieldCheckIcon className="w-6 h-6 text-green-500 mr-2" data-id="element-133" />
          <span data-id="element-134">✅ Garantía de satisfacción de 7 días</span>
        </div>
      </div>
    </section>;
}